import { Component } from 'react';

/*
 * Catches a crash inside one page so the whole screen doesn't go blank.
 * Shows a small message with a Reload button instead, and clears itself
 * when the URL changes (resetKey), so moving to another page just works.
 */
export default class RouteErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // keep it in the console for debugging
        console.error('Page crashed:', error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ error: null });
        }
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div style={{ padding: '48px 16px', textAlign: 'center', color: '#344054' }}>
                <h3 style={{ margin: '0 0 8px' }}>Something went wrong on this page</h3>
                <p style={{ margin: '0 0 16px', color: '#667085' }}>Please reload to try again.</p>
                <button
                    type='button'
                    onClick={() => window.location.reload()}
                    style={{
                        padding: '10px 22px',
                        border: 'none',
                        borderRadius: 8,
                        background: '#006aff',
                        color: '#fff',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}
                >
                    Reload
                </button>
            </div>
        );
    }
}
